import { render } from "./view-calendar.vue?vue&type=template&id=726a6813"
import script from "./view-calendar.vue?vue&type=script&lang=js"
export * from "./view-calendar.vue?vue&type=script&lang=js"

import "./view-calendar.vue?vue&type=style&index=0&id=726a6813&lang=css"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__